module.exports = __webpack_public_path__ + "static/media/logoGarpix.6d4026ec.svg";